export type LanguageId = "de" | "en";
export const SUPPORTED_LANGUAGES = [
  { id: "de", label: "Deutsch" },
  { id: "en", label: "English" },
  { id: "es", label: "Español" },
  { id: "is", label: "Íslenska" },
  { id: "hi", label: "हिंदी" },
  { id: "ar", label: "عربي" },
];

export const SUPPORTED_LANGUAGES_MAP = SUPPORTED_LANGUAGES.reduce(
  (acc, lang) => ({ ...acc, [lang.id]: lang.label }),
  {} as Record<LanguageId, string>
);

export const Module = {
  Analytics: "analytics",
  Reflection: "reflection",
  Solution: "solution",
} as const;

export const MODULE_ORDER: ModuleEnum[] = [
  Module.Analytics,
  Module.Reflection,
  Module.Solution,
];

export type ModuleEnum = typeof Module[keyof typeof Module];

export const DEFAULT_BENCHMARK_VALUE = 0.72;
